import types from 'actions/types'
import { combineReducers } from 'redux'
import { createPivotTableReducer } from 'reducers/pivotTable'
import {get} from 'lodash'

const job = (state = null, action) => {
  switch (action.type) {

    // optimistic
    case types.SETTINGS_CONTACT_IMPORT_JOB_UPDATE_ATTEMPT:
    case types.SETTINGS_CONTACT_IMPORT_JOB_VALIDATE_ATTEMPT:
    case types.SETTINGS_CONTACT_IMPORT_JOB_PRECOMMIT_ATTEMPT:
    case types.SETTINGS_CONTACT_IMPORT_JOB_COMMIT_ATTEMPT:
      return action.job || state

    case types.SETTINGS_CONTACT_IMPORT_JOB_UPLOAD_ATTEMPT:
      return { ...state, uploading: true }

    case types.SETTINGS_CONTACT_IMPORT_CHANGE_STEP:
      if (action.step === 0) return { ...state, uploaded: false }
      return state

    case types.SETTINGS_CONTACT_IMPORT_JOB_RESET_ATTEMPT:
      return {
        ...state,
        imported: false,
        committing: false,
        uploaded: false,
        error: null,
        status: null,
        progress: 0,
        completed: true,
        fields: [],
        fileValidity: null,
        commitValidity: null,
      }

    // reactive
    case types.SETTINGS_CONTACT_IMPORT_JOB_READ_SUCCESS:
    case types.SETTINGS_CONTACT_IMPORT_JOB_UPDATE_SUCCESS:
    case types.SETTINGS_CONTACT_IMPORT_JOB_VALIDATE_SUCCESS:
    case types.SETTINGS_CONTACT_IMPORT_JOB_PRECOMMIT_SUCCESS:
    case types.SETTINGS_CONTACT_IMPORT_JOB_COMMIT_SUCCESS:
    case types.SETTINGS_CONTACT_IMPORT_JOB_RESET_SUCCESS:
      return action.data

    case types.SETTINGS_CONTACT_IMPORT_JOB_UPLOAD_SUCCESS:
      return { ...state, uploading: false, uploaded: true }

    case types.SETTINGS_CONTACT_IMPORT_JOB_UPLOAD_FAILURE:
      return { ...state, uploading: false }

    default: return state
  }
}

const loading = (state = false, action) => {
  switch (action.type) {
    case types.SETTINGS_CONTACT_IMPORT_JOB_READ_ATTEMPT: return true
    case types.SETTINGS_CONTACT_IMPORT_JOB_READ_SUCCESS:
    case types.SETTINGS_CONTACT_IMPORT_JOB_READ_FAILURE: return false
    default: return state
  }
}

const validating = (state = false, action) => {
  switch (action.type) {
    case types.SETTINGS_CONTACT_IMPORT_JOB_VALIDATE_ATTEMPT: return true
    case types.SETTINGS_CONTACT_IMPORT_JOB_VALIDATE_SUCCESS:
    case types.SETTINGS_CONTACT_IMPORT_JOB_VALIDATE_FAILURE: return false
    default: return state
  }
}

const precommiting = (state = false, action) => {
  switch (action.type) {
    case types.SETTINGS_CONTACT_IMPORT_JOB_PRECOMMIT_ATTEMPT: return true
    case types.SETTINGS_CONTACT_IMPORT_JOB_PRECOMMIT_SUCCESS:
    case types.SETTINGS_CONTACT_IMPORT_JOB_PRECOMMIT_FAILURE: return false
    default: return state
  }
}

const commiting = (state = false, action) => {
  switch (action.type) {
    case types.SETTINGS_CONTACT_IMPORT_JOB_COMMIT_ATTEMPT: return true
    case types.SETTINGS_CONTACT_IMPORT_JOB_COMMIT_SUCCESS:
    case types.SETTINGS_CONTACT_IMPORT_JOB_COMMIT_FAILURE: return false
    default: return state
  }
}

const filters = (state = null, action) => {
  switch (action.type) {
    case types.SETTINGS_CONTACT_IMPORT_UPDATE_FILTERS: return { ...state, ...action.filters }
    default: return state
  }
}

const hasFileErrors = (job) => {
  const entries = get(job, ['fileValidity', 'entries', 'ERROR'])
  return (entries && entries.length > 0)
}

const currentStep = (state = 0, action) => {
  switch (action.type) {
    case types.SETTINGS_CONTACT_IMPORT_JOB_READ_SUCCESS:
    case types.SETTINGS_CONTACT_IMPORT_JOB_UPDATE_SUCCESS:
    case types.SETTINGS_CONTACT_IMPORT_JOB_VALIDATE_SUCCESS:
    case types.SETTINGS_CONTACT_IMPORT_JOB_PRECOMMIT_SUCCESS:
    case types.SETTINGS_CONTACT_IMPORT_JOB_COMMIT_SUCCESS:
      if (action.data) {
        if (action.data.uploaded && state < 1) return 1         // progress if uploaded
        if (state > 1 && hasFileErrors(action.data)) return 1   // regress if file validation errors
      }
      return state

    case types.SETTINGS_CONTACT_IMPORT_JOB_UPLOAD_SUCCESS: return 1 // progress on upload
    case types.SETTINGS_CONTACT_IMPORT_CHANGE_STEP: return action.step

    default: return state
  }
}

export default combineReducers({
  pivotTable: createPivotTableReducer({key: 'settingsContext.contactImport.pivotTable', defaultSortColumn: 'row', defaultSortDirection: 'asc', pageSize: 50}),
  job,
  loading,
  validating,
  precommiting,
  commiting,
  filters,
  currentStep,
})
